import appCorporateTransportationSubmissions from "../../views/appSettings/corporateTransportationSubmissions.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "corporate-transportation-submissions";
  const params = ["page", "limit"];

  $stateProvider.state("corporatetransportationsubmissions", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCorporateTransportationSubmissions,
      },
    },
    reloadOnSearch: false,
    data: { title: "CorporateTransportationSubmissions" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/corporateTransportationSubmissions/corporateTransportationSubmissions.urls.js